import { useCallback, useState } from "react";
import { RelatorioComposicaoReceitasQueryParams } from "core/features/relatorios/conta-com-composicoes/typings";
import { RelatorioReceitaComposicaoHorizontalEvents } from "core/features/relatorios/enums/events";
import moment from "moment";
import { trackEvent } from "infra/helpers/event";
import { PaginateQuery } from "core/resources/types/shared";

export const defaultFiltroRelatorioComposicaoReceitas: RelatorioComposicaoReceitasQueryParams &
  PaginateQuery = {
  search: "",
  tipoData: "movimentacao",
  dataInicio: moment().startOf("month").format("YYYY-MM-DD"),
  dataFim: moment().format("YYYY-MM-DD"),
  page: 1,
  limit: 10,
  centrosDeCustoIds: [],
  contasBancariasIds: [],
};

function useFiltroRelatorioComposicaoReceitasHorizontal() {
  const [filtro, setFiltro] = useState<
    RelatorioComposicaoReceitasQueryParams & PaginateQuery
  >(defaultFiltroRelatorioComposicaoReceitas);

  const onChangeFiltro = useCallback(
    (
      _filtro: Partial<RelatorioComposicaoReceitasQueryParams & PaginateQuery>
    ) => {
      trackEvent(RelatorioReceitaComposicaoHorizontalEvents.Filtrar);
      setFiltro((state) => ({ ...state, ..._filtro }));
    },
    []
  );

  const onResetFiltro = useCallback(() => {
    setFiltro(defaultFiltroRelatorioComposicaoReceitas);
  }, []);

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
    onResetFiltro,
  };
}

export default useFiltroRelatorioComposicaoReceitasHorizontal;
